import React, { Component } from 'react';
import ValueField from 'components/connectedForm/ValueField';
import componentStyles from 'styles/partials/_file-selector.css';
import inputStyles from 'styles/partials/_baseinput.css';
import { appActions } from 'state/modules/app';

export default class ImageSelector extends Component {
  constructor(props) {
    super(props);
    this.getErrorMessage = this.getErrorMessage.bind(this);
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleImageRemoval = this.handleImageRemoval.bind(this);
    this.renderRemoveOption = this.renderRemoveOption.bind(this);
    this.handleFileUpload = this.handleFileUpload.bind(this);
    this.styles = {};
    Object.assign(this.styles, componentStyles, inputStyles);

    this.imageInputRef = React.createRef();
    this.fileSelectorRef = React.createRef();

    this.state = {
      imageHash: Date.now(),
    };
  }

  focus() {
    this.imageInputRef.current.focus();
  }

  render() {
    const { message, value, readOnly, includeLabel, align } = this.props;

    const imageName = this.props.value || 'default-no-image.png';

    let styleName = '';
    let errorMessage = '';
    if (message !== undefined && message.length > 0) {
      styleName = 'invalid';
      errorMessage = this.getErrorMessage(message);
    }

    let className = this.styles.selector;
    className += this.props.hiddenClass ? ` ${this.styles.hidden}` : '';

    const DropDownArea = readOnly ? null : <span className="dropdownArrow" onClick={this.handleEditClick} />;
    const DropDownIcon = readOnly ? null : (
      <span className={this.styles.dropDownIcon} onClick={this.handleEditClick}>
        <i className="icon">file_upload</i>
      </span>
    );
    const disabled = readOnly ? true : null;

    const imageEndpoint = this.props.imageEndPoint
      ? `${this.props.imageEndPoint}/${imageName}`
      : `resources/image/${imageName}`;

    return (
      <div className={className}>
        <div className={`${this.styles.inputGroup} ${this.styles.selector} ${this.styles[styleName]}`}>
          {!readOnly ? (
            <ValueField
              value={value}
              label={this.props.label ? this.props.label : 'Main Image'}
              includeLabel={includeLabel}
              align={align}
              type="text"
              iconSuffix={true}
            />
          ) : null}
          {DropDownArea}
          {DropDownIcon}
          {errorMessage}
          <input
            type="file"
            onChange={(e) => this.handleImageSelect(e)}
            style={{ display: 'none' }}
            ref={this.fileSelectorRef}
            accept="image/*"
            disabled={disabled}
          />
        </div>

        <div className={this.styles.inputGroup}>
          {includeLabel ? <label className={this.styles.valueLabel} /> : null}
          <div
            className={`${this.styles[`${includeLabel ? 'frame' : 'frameWithoutLabel'}`]} ${this.styles.inputControl}`}
            onDragEnter={(e) => this.stopPropagation(e)}
            onDragOver={(e) => this.stopPropagation(e)}
            onDragExit={(e) => this.stopPropagation(e)}
            onDrop={(e) => this.handleImageDrop(e)}
            onClick={(e) => this.handleImageClick(e)}
            ref={this.imageInputRef}
            tabIndex={this.props.tabIndex}
          >
            <div style={{ height: '150px' }}>
              <img src={`/api/${imageEndpoint}?${this.state.imageHash}`} style={{ maxHeight: '100%' }} />
            </div>
            {!readOnly ? <div>Drag image here to update</div> : null}
          </div>
          {this.renderRemoveOption()}
        </div>
      </div>
    );
  }

  renderRemoveOption() {
    if (this.props.value && this.props.value !== '' && !this.props.readOnly) {
      return (
        <div className={this.styles.removeLink} onClick={this.handleImageRemoval}>
          <span className="icon">delete</span>
          <span> Remove Image</span>
        </div>
      );
    }
  }

  stopPropagation(event) {
    event.stopPropagation();
    event.preventDefault();
  }

  handleImageDrop(event) {
    event.preventDefault();
    this.handleFileUpload(event.dataTransfer.files[0]);
  }

  handleImageSelect(event) {
    event.preventDefault();
    this.handleFileUpload(event.target.files[0]);
  }

  handleFileUpload(file) {
    if (this.props.readOnly) return;
    const fr = new FileReader();
    fr.onload = function (e) {
      const formData = new FormData();
      formData.append('file', file);

      const onSuccess = (response) => {
        if (response.response.successful) {
          this.props.onChange(response.response.filename);
          this.setState({
            imageHash: Date.now(),
          });
        }
      };

      if (this.props.endPoint) {
        this.props.dispatch(appActions.uploadFile(formData, this.props.endPoint)).then(onSuccess);
      } else {
        this.props.dispatch(appActions.uploadImage(formData)).then(onSuccess);
      }
    }.bind(this);
    fr.readAsDataURL(file);
  }

  handleImageRemoval(event) {
    event.preventDefault();
    this.props.onChange('');
  }

  // Allow click to change image if blank
  handleImageClick(event) {
    event.preventDefault();
    if (!this.props.value || this.props.value === '') {
      this.handleEditClick();
    }
  }

  getErrorMessage(message) {
    return <div className={this.styles.errorMessage}>{message[0].message}</div>;
  }

  handleEditClick() {
    const clickEvent = new MouseEvent('click', {
      view: window,
      bubbles: false,
      cancelable: false,
    });
    this.fileSelectorRef.current.dispatchEvent(clickEvent);
  }
}
ImageSelector.defaultProps = {
  align: 'left',
  includeLabel: true,
};
